import { useInfiniteQuery } from "@tanstack/react-query";
import { ApiError } from "src/types/interfaces/api-error";
import { NotificationSearchState } from "../../shared/types/payloads/notification-search-state.payload";
import { NotificationI } from "../../shared/types/responses/notification.response";
import { notificationsKeys } from "../api/lib/query-keys/notifications";
import { siteNotificationsApi } from "../api/lib/notifications";
import { PaginatedDataV4 } from "src/types/responses/paginated-data-v4";

export const useInfiniteNotifications = (
  perPage: number,
  searchState: NotificationSearchState,
  enabled: boolean = true,
) => {
  return useInfiniteQuery<PaginatedDataV4<NotificationI>, ApiError>({
    queryKey: notificationsKeys.infiniteList(perPage, searchState),
    queryFn: ({ pageParam = 1 }) => {
      return siteNotificationsApi.fetchNotifications(pageParam, perPage, searchState);
    },
    getNextPageParam: (lastPage, allPages) => {
      const nextPage =
        lastPage.items.length === lastPage.pagination.perPage ? allPages.length + 1 : undefined;

      if (nextPage === undefined) {
        return undefined;
      }

      const alreadyFetchedAllItems =
        allPages.length * lastPage.pagination.perPage === lastPage.pagination.total;

      if (alreadyFetchedAllItems) {
        return undefined;
      }

      return nextPage;
    },
    enabled,
    keepPreviousData: true,
  });
};
